import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import success from "assets/images/check-circle.svg";
import close from "assets/images/close.svg";

const usePopup = () => {
  let [msg, setMsg] = useState("");

  let [popUp, setPopUp] = useState(false);

  const togglePopUp = () => {
    setPopUp(!popUp);
  };

  const successPopUp = () => {
    return (
      <Modal isOpen={popUp} toggle={togglePopUp}>
        <ModalBody>
          <div className="success_popup">
            <img
              src={close}
              className="close_icon"
              onClick={() => togglePopUp()}
            />
            <img src={success} />
            <b>{msg}</b>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  return {
    successPopUp,
    setMsg,
    togglePopUp,
  };
};

export default usePopup;
